<template>
  <div class="containerGeralNfe">
    <div class="title">
      <b-icon-file-earmark-medical></b-icon-file-earmark-medical>
      <span> Nota Fiscal</span>
    </div>
    <div class="rowContent" style="margin-bottom: 20px">
      <div class="btnsContainer">
        <b-button class="btnsSave" @click="openModals('modalTaxInformation')">
          + Nova Ref. Fiscal
        </b-button>
      </div>
      <div class="additionalButtonContent">
        <div class="containerCheckBox">
          <b-form-group
            style="margin-bottom: 1rem"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox
              :aria-describedby="ariaDescribedby"
              value="0"
              unchecked-value="1"
              class="chkSaidaEntrada"
              v-model="dadosNfe.operacao"
              size="sm"
              switch
            >
              <div style="width: 90px; font-size: 12px">
                {{ textoTipoEmissao }}
              </div>
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="rowContainer">
      <span>
        <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
        Gerais</span
      >
      <div class="rowContent">
        <b-form-group hidden>
          <b-form-input
            hidden
            type="text"
            size="sm"
            v-model="dadosNfe.id"
          ></b-form-input>
        </b-form-group>

        <!-- <InputSelect
          label="Cliente"
          :items="cliente"
          :dataSelect.sync="dadosNfe.idCliente"
          :openCreateModal="() => openModals('modalCreateCustomer')"
          ref="refCliente"
          valueField="id"
          textField="nome"
        /> -->
        <div class="inputCustomer">
          <InputInfinit
            label="Cliente"
            :isEdit="dadosNfe.idCliente"
            :dataInput.sync="dadosNfe.idCliente"
            :onSearch="fillCustomerComboBoxWithPaginate"
            :openCreateModal="() => openModals('modalCreateCustomer')"
            :clearSelected="newOrder"
            :findAll="createdNewCustomer"
            @selectItem="handleDataCustomers($event)"
          />
        </div>

        <div class="input-group inputdate">
          <input
            type="datetime-local"
            class="input borderInput"
            v-model="dadosNfe.data_nfe"
          />
          <label class="user-label-data"> Data de Emissão </label>
        </div>

        <div class="input-group inputdate">
          <input
            type="datetime-local"
            class="input borderInput"
            v-model="dadosNfe.data_entrada_saida"
          />
          <label class="user-label-data"> Data Entrada / Saída </label>
        </div>

        <InputSelect
          style="width: 25%"
          label="Natureza operação"
          :items="allNatures"
          valueField="id"
          textField="descricao"
          :dataSelect.sync="dadosNfe.idNatureOp"
          :openCreateModal="() => openModals('modalNatures')"
          @changed="assingNatureOp(dadosNfe.idNatureOp)"
          ref="refNop"
        />
      </div>
      <div class="rowContent">
        <div class="selectPlusSm" style="width: 20% !important">
          <label class="user-label-disabled">Finalidade</label>
          <b-form-select
            class="borderInput shadow-none"
            value-field="value"
            text-field="text"
            v-model="dadosNfe.finalidade"
            :options="finalidade"
          >
          </b-form-select>
        </div>

        <div class="input-group">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.nfe"
          />
          <label class="user-label-disabled"> Nº </label>
        </div>
        <div class="input-group">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.chave"
          />
          <label class="user-label-disabled"> Chave </label>
        </div>
        <div class="input-group">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.serie"
          />
          <label class="user-label-disabled"> Serie </label>
        </div>
        <div class="input-group">
          <input class="input borderInput" disabled v-model="dadosNfe.status" />
          <label class="user-label-disabled"> Status </label>
        </div>
        <div class="selectPlusSm">
          <label class="user-label-disabled">Ambiente</label>
          <b-form-select
            class="borderInput shadow-none"
            value-field="value"
            text-field="text"
            v-model="dadosNfe.ambiente"
            :options="ambiente"
          >
          </b-form-select>
        </div>
      </div>
      <div class="rowContent" v-if="dadosNfe.finalidade == '4' || dadosNfe.finalidade == '3'">
        <div class="selectPlus">
          <label class="user-label-disabled">Tipo de referenciamento</label>
          <b-form-select
            class="borderInput shadow-none"
            value-field="value"
            text-field="text"
            v-model="typeReferenciamento"
            :options="typeReferenciamentoOptions"
          />
        </div>
        <div class="input-group" v-if="typeReferenciamento === 2">
          <input
            class="input borderInput"
            v-model="dadosNfe.nfe_referenciada"
          />
          <label class="user-label"> Chave de Referência </label>
        </div>
      </div>
    </div>
    <b-row
      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex mt-3 contentDataNfeRow"
    >
      <b-form-group
        class="col-sm-6 col-md-6 col-lg-6 col-xl-6"
        v-if="(dadosNfe.finalidade == '4') & (dadosNfe.operacao == '0')"
      >
        <InputSearchSelect
          label="REF Fiscal"
          valueField="ref"
          textField="descricao"
          :items="allRefsFiscaisFromSelectBox"
          :additionalFilters="refFiscalFilters"
          @openFilters="loadRefFiscalCategories"
          :dataSelect.sync="classeImpostoDevolucao"
          :enableIconCreate="false"
        />
      </b-form-group>
    </b-row>

    <b-card-text
      class="mt-3"
      :hidden="
        (dadosNfe.finalidade == '4') & (dadosNfe.operacao == '0') ? true : false
      "
    >
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-produtos"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div @click="clickProductAndSave" class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #006256"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #006256">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">
                  Adicionar Produto
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-produtos"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card class="mt-2 cardDadosNfeBorda">
                <div class="rowContent">
                  <div
                    style="padding: 0px !important"
                    class="col-sm-6 col-md-6 col-lg-5 col-xl-6"
                  >
                    <InputInfinit
                      label="Produtos"
                      :isEdit="produtosNotaFiscal.id"
                      :dataInput.sync="produtosNotaFiscal.idProduto"
                      :onSearch="fillProductsComboBoxWithPaginate"
                      :openCreateModal="
                        () =>
                          handleModalCreateProduct(
                            'modalCreateProduct',
                            produtosNotaFiscal.idProduto
                          )
                      "
                      :findAll="createdNewProducts"
                      :clearSelected="toggleClearSelect"
                      :searchFields="['nome', 'codRef']"
                      @selectItem="assignValuesToTheSelectedProduct"
                    />
                  </div>

                  <div class="input-group" style="width: 15% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.codigo"
                      disabled
                    />
                    <label class="user-label-disabled"> Cod. Ref </label>
                  </div>

                  <div class="selectPlus">
                    <label class="fixedSelect2">Unidade</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      :options="unidade"
                      v-model="produtosNotaFiscal.unidade"
                    >
                    </b-form-select>
                  </div>

                  <div class="input-group" style="width: 10% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.ncm"
                    />
                    <label class="user-label-ncm"> NCM </label>
                  </div>
                </div>
                <div class="rowContent" style="align-items: center">
                  <div
                    :class="[
                      'item-tax-ref-field',
                      {
                        'item-tax-ref-field-ref':
                          !produtosNotaFiscal.usar_imposto_manual,
                      },
                    ]"
                  >
                    <ItemManualTax
                      :item="produtosNotaFiscal"
                      modal-id="nota-item-manual-tax"
                    />

                    <InputSearchSelect
                      style="width: calc(100% - 30px)"
                      label="REF Fiscal"
                      valueField="ref"
                      textField="descricao"
                      :items="allRefsFiscaisFromSelectBox"
                      :additionalFilters="refFiscalFilters"
                      @openFilters="loadRefFiscalCategories"
                      :dataSelect.sync="produtosNotaFiscal.classe_imposto"
                      labelFixed="true"
                      :openCreateModal="handleOpenModalRef"
                      @changed="assignItemTaxFromRef"
                      ref="classe_imposto"
                    />
                  </div>

                  <InputQuant
                    label="Quant."
                    type="text"
                    style="width: 10% !important"
                    :dataInput.sync="produtosNotaFiscal.quantidade"
                    @changed="formatTotalProductValue"
                    ref="quantidade"
                  />

                  x

                  <div class="input-group" style="width: 20%">
                    <input
                      required
                      class="input borderInput"
                      size="sm"
                      :value="maskCurrency(produtosNotaFiscal.subtotal)"
                      @input="handleSubtotalMonetaryValue"
                      @keyup="formatTotalProductValue"
                    />
                    <label class="user-label"> Valor Unitário </label>
                  </div>

                  =

                  <div class="input-group" style="width: 20%">
                    <input
                      required
                      class="input borderInput"
                      disabled
                      :value="
                        handleTotalproductsValue(produtosNotaFiscal.total)
                      "
                    />
                    <label class="user-label-disabled"> Valor Total </label>
                  </div>

                  <InputMoney
                    style="width: 15% !important"
                    v-if="!discountIsCheked"
                    label="Desconto"
                    :labelFixed="true"
                    type="text"
                    :dataInput.sync="produtosNotaFiscal.desconto"
                    ref="discount"
                    @calculateTotal="formatTotalProductValue"
                  />
                  <InputPercentage
                    v-else
                    style="width: 15% !important"
                    label="% Desconto"
                    :labelFixed="true"
                    type="text"
                    :dataInput.sync="produtosNotaFiscal.desconto"
                    ref="discount"
                    @calculateTotal="formatTotalProductValue"
                  />

                  <div class="itemToggleDesc">
                    <label class="switch">
                      <input
                        type="checkbox"
                        ref="typeDiscount"
                        @click="alterDiscountIsCheked"
                        v-model="discountIsCheked"
                      />
                      <div class="slider">
                        <span>R$</span>
                        <span>%</span>
                      </div>
                    </label>
                  </div>
                </div>
                <div
                  class="rowContent"
                  v-if="(dadosNfe.finalidade == '4' || dadosNfe.finalidade == '3') && typeReferenciamento === 1"
                >
                  <div class="input-group">
                    <input class="input borderInput" v-model="produtosNotaFiscal.dfe_referenciado.chave" />
                    <label class="user-label">Chave DF-e referenciada *</label>
                  </div>
                  <div class="input-group">
                    <input class="input borderInput" v-model="produtosNotaFiscal.dfe_referenciado.item" />
                    <label class="user-label">Nº item na DF-e referenciada *</label>
                  </div>
                </div>
                <div class="rowContent">
                  <div class="input-group" style="width: 45% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.informacoes_adicionais"
                    />
                    <label class="user-label"> Dados Adicionais </label>
                  </div>
                  <div class="selectPlus" style="width: 45% !important">
                    <label class="user-label-disabled">Origem</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="produtosNotaFiscal.origem"
                      :options="origem"
                    >
                    </b-form-select>
                  </div>

                  <div class="input-group" style="width: 15% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.peso"
                    />
                    <label class="user-label"> Peso (KG) </label>
                  </div>
                  <b-button
                    class="btnsSave"
                    style="width: 120px !important"
                    @click="saveOrUpdateNotaItems"
                    >Adicionar</b-button
                  >
                </div>

                <div class="ContentTable">
                  <table style="width: 100%">
                    <thead
                      style="
                        background-color: #3a4750 !important;
                        color: whitesmoke;
                        text-align: center;
                        height: 27px;
                      "
                    >
                      <tr>
                        <th>Nome Produto</th>
                        <th>Quantidade</th>
                        <th>Vl. unitario</th>
                        <th>Vl. total</th>
                        <th>Desconto</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody style="color: #3a4750; width: 100%">
                      <tr
                        v-for="notaItem in produtosForTable"
                        :key="notaItem.id"
                        style="text-align: center; height: 27px"
                      >
                        <td>{{ notaItem.nome }}</td>
                        <td>{{ notaItem.quantidade }}</td>
                        <td>
                          {{
                            notaItem.subtotal.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td>
                          {{ maskCurrency(notaItem.total) }}
                        </td>
                        <td>
                          {{
                            notaItem.desconto
                              ? notaItem.desconto.toLocaleString("pt-br", {
                                  style: "currency",
                                  currency: "BRL",
                                })
                              : "0,00"
                          }}
                        </td>
                        <td>
                          <b-button
                            size="sm"
                            variant="light"
                            style="color: black"
                            @click="editProductsOfSale(notaItem.id)"
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Editar',
                            }"
                          >
                            <b-icon-pencil-square></b-icon-pencil-square
                          ></b-button>
                          <b-button
                            size="sm"
                            variant="light"
                            style="color: red"
                            :disabled="
                              responseNfeWebMania.status === 'aprovado' ||
                              responseNfeWebMania.status === 'processamento'
                                ? true
                                : false
                            "
                            @click="deleteProductFromNote(notaItem.id)"
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Excluir',
                            }"
                          >
                            <b-icon-x-circle></b-icon-x-circle
                          ></b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text
      class="mt-3"
      :hidden="
        (dadosNfe.finalidade == '4') & (dadosNfe.operacao == '0') ? true : false
      "
    >
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-pedido"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #006256"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #006256">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">
                  Dados Pedido
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-pedido"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card class="mt-2 cardDadosNfeBorda">
                <div class="rowContent">
                  <div class="selectPlus">
                    <label class="user-label-disabled">Frete</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      @change="enableFreightage"
                      v-model="dadosNfe.modalidade_frete"
                      :options="modalidade_frete"
                    >
                    </b-form-select>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Condição de Pagamento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.pagamento"
                      :options="pagamento"
                    >
                    </b-form-select>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Forma de Pagamento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.forma_pagamento"
                      :options="forma_pagamento"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group">
                    <b-form-input
                      class="input borderInput"
                      :value="maskCurrency(dadosNfe.valor_pagamento)"
                      @input="handlePaymentValue($event)"
                    />
                    <label class="user-label"> Valor do pagamento </label>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled">Presença</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.presenca"
                      :options="presenca"
                    >
                    </b-form-select>
                  </div>
                </div>
                <div class="rowContent">
                  <div class="input-group">
                    <b-form-input
                      class="input borderInput"
                      :value="maskCurrency(dadosNfe.frete)"
                      @input="handleFreteMonetaryValue($event)"
                      @change="calculateTotalAndTotalDiscount"
                    />
                    <label class="user-label"> Valor do Frete </label>
                  </div>
                  <div class="input-group">
                    <b-form-input
                      class="input borderInput"
                      :value="maskCurrency(dadosNfe.despesas_acessorias)"
                      @input="handleExpensesMonetaryValue($event)"
                      @change="calculateTotalAndTotalDiscount"
                    />
                    <label class="user-label"> Outras Despesas </label>
                  </div>
                  <div class="input-group">
                    <b-form-input
                      class="input borderInput"
                      disabled
                      @change="calculateTotalAndTotalDiscount"
                      @keypress="defineMaxLengthDiscount"
                      :value="maskCurrency(dadosNfe.desconto)"
                      @input="handleTotalDiscount"
                    />
                    <label class="user-label-disabled"> Desconto </label>
                  </div>
                  <div class="input-group">
                    <b-form-input
                      class="input borderInput"
                      disabled
                      :value="handleTotalValue(dadosNfe.total)"
                    />
                    <label class="user-label-disabled"> Valor Total </label>
                  </div>
                </div>

                <div class="rowContent">
                  <div class="selectPlus" style="width: 130px">
                    <label class="user-label-disabled"
                      >Defensivos na nota ?</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.defensivosNaNota"
                    >
                      <b-form-select-option :value="true"
                        >Sim</b-form-select-option
                      >
                      <b-form-select-option :value="false"
                        >Não</b-form-select-option
                      >
                    </b-form-select>
                  </div>
                </div>

                <div class="mt-3">
                  <p class="descriptionObs">Informações complementares</p>

                  <textarea
                    class="inputTextArea"
                    rows="3"
                    max-rows="6"
                    v-model="dadosNfe.informacoes_complementares"
                  />
                </div>

                <div class="rowContent" v-if="exibirDadosIntermediador">
                  <div class="selectPlus">
                    <label class="user-label-disabled">Intermediador</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.intermediador"
                      :options="intermediador"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="dadosNfe.id_intermediador"
                    />
                    <label class="user-label"> Nome do Intermediador </label>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="dadosNfe.cnpj_intermediador"
                    />
                    <label class="user-label"> CNPJ do Intermediador </label>
                  </div>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text class="mt-3" :hidden="isDisabled">
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-transportadora"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #006256"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #006256">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 12px">
                  Transportadora
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-transportadora"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card class="mt-2 cardDadosNfeBorda">
                <div class="rowContent rowContentShippingCompany">
                  <InputSelect
                    label="Nome da Transportadora"
                    valueField="id"
                    textField="nome"
                    :items="shippingCompanys"
                    :dataSelect.sync="dadosNfe.idTransportadora"
                    labelFixed="true"
                    :openCreateModal="() => openModals('modalShippingCompany')"
                    ref="refShippingCompapy"
                    class="inputNameShippingCompany"
                  />

                  <div class="input-group inputShippingCompanyMd">
                    <b-form-input
                      class="input borderInput"
                      v-model="dadosNfe.volume"
                    />
                    <label class="user-label"> Volume </label>
                  </div>

                  <div class="input-group inputShippingCompanyMd">
                    <b-form-input
                      class="input borderInput"
                      v-model="dadosNfe.especie"
                    />
                    <label class="user-label"> Especie </label>
                  </div>

                  <div class="input-group inputShippingCompanyMd">
                    <b-form-input
                      class="input borderInput"
                      :value="maskToKg(dadosNfe.peso_bruto)"
                      @input="handleGrossWeight($event)"
                    />
                    <label class="user-label"> Peso Bruto </label>
                  </div>

                  <div class="input-group inputShippingCompanyMd">
                    <b-form-input
                      class="input borderInput"
                      :value="maskToKg(dadosNfe.peso_liquido)"
                      @input="handleNetWeight($event)"
                    />
                    <label class="user-label"> Peso Liquido </label>
                  </div>
                </div>

                <div class="rowContent rowContentShippingCompany">
                  <div class="input-group inputShippingCompanySm">
                    <b-form-input
                      class="input borderInput"
                      v-model="dadosNfe.marca"
                    />
                    <label class="user-label"> Marca </label>
                  </div>

                  <div class="input-group inputShippingCompanySm">
                    <b-form-input
                      class="input borderInput"
                      v-model="dadosNfe.numeracao"
                    />
                    <label class="user-label"> Numeração </label>
                  </div>

                  <div class="input-group inputShippingCompanySm">
                    <b-form-input
                      class="input borderInput"
                      v-model="dadosNfe.lacres"
                    />
                    <label class="user-label"> lacres </label>
                  </div>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text class="mt-3" :hidden="!dadosNfe.defensivosNaNota">
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-agropecuaria"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #006256"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #006256">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 12px">
                  Dados Agropecuários
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-agropecuaria"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card
                class="cardDadosNfeBorda"
                style="margin-top: 0 !important"
              >
                <Tabs
                  :tabs="tabs"
                  :tabSelected="tabSelected"
                  :noPadding="true"
                  fontSizeTitle="10px"
                >
                  <template v-slot:defensivos>
                    <div class="summaryForm mt-1">
                      <div style="display: flex; gap: 1rem">
                        <div class="input-group" style="width: 150px">
                          <input
                            required
                            class="input borderInput"
                            v-model="defensivos.numero_receituario"
                          />
                          <label class="user-label"> Número Receituário </label>
                        </div>

                        <div class="input-group" style="width: 180px">
                          <input
                            required
                            class="input borderInput"
                            v-model="defensivos.cpf_responsavel_tecnico"
                            v-mask="maskCpf"
                            maxlength="18"
                            @input="checkInputLength"
                          />
                          <label class="user-label">
                            CPF Responsável Técnico
                          </label>
                        </div>

                        <b-button
                          class="btnsSave"
                          style="
                            width: 30px !important;
                            font-size: 14px;
                            padding: 0;
                          "
                          @click="addPrescriptionData"
                          >+</b-button
                        >
                      </div>

                      <p
                        v-if="dadosNfe.agropecuario.defensivos.length"
                        style="
                          margin: 1rem 0 0 0;
                          padding: 0.3rem 0;
                          border-bottom: solid 1px rgb(179 178 176 / 35%);
                        "
                      >
                        Items adicionados
                      </p>

                      <div style="display: flex; gap: 1rem; margin-top: 1rem">
                        <div
                          v-for="(def, idx) in dadosNfe.agropecuario.defensivos"
                          :key="idx"
                        >
                          <div class="contentRemovePescription">
                            <p style="margin: 0; font-size: 11px">
                              <b-icon-card-text style="margin-right: 0.3rem" />
                              {{ def.numero_receituario }}
                            </p>

                            <p style="margin: 0; font-size: 11px">
                              <b-icon-person-bounding-box
                                style="margin-right: 0.3rem"
                              />
                              {{ maskCpfCnpj(def.cpf_responsavel_tecnico) }}
                            </p>

                            <div
                              class="iconRemovePrescription"
                              @click="removePrescriptionItem(idx)"
                            >
                              X
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:guiaDeTransito>
                    <div class="summaryForm marginFormSearch">
                      <div style="display: flex; gap: 1rem">
                        <div class="selectPlus">
                          <label class="user-label-disabled">Tipo</label>
                          <b-form-select
                            class="borderInput shadow-none"
                            value-field="value"
                            text-field="text"
                            v-model="dadosNfe.agropecuario.guia_transito.tipo"
                            :options="tiposGuiaDeTransito"
                          >
                          </b-form-select>
                        </div>

                        <div class="selectPlus" style="width: 50px">
                          <label class="user-label-disabled">UF</label>
                          <b-form-select
                            class="borderInput shadow-none"
                            value-field="value"
                            text-field="text"
                            v-model="dadosNfe.agropecuario.guia_transito.uf"
                            :options="ufs"
                          >
                          </b-form-select>
                        </div>

                        <div class="input-group" style="width: 100px">
                          <input
                            class="input borderInput"
                            v-model="dadosNfe.agropecuario.guia_transito.serie"
                            type="number"
                          />
                          <label class="user-label"> Serie </label>
                        </div>

                        <div class="input-group" style="width: 100px">
                          <input
                            class="input borderInput"
                            v-model="dadosNfe.agropecuario.guia_transito.numero"
                            type="number"
                          />
                          <label class="user-label"> Número </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </Tabs>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text
      class="mt-3"
      :hidden="
        (dadosNfe.finalidade == '4') & (dadosNfe.operacao == '0') ? true : false
      "
    >
      <div>
        <b-navbar toggleable class="cardDadosNfe" style="margin-bottom: 100px">
          <b-navbar-toggle
            target="navbar-toggle-collapse-duplicatas"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCardFinaly">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #006256"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #006256">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">Duplicatas</div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-duplicatas"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav>
              <b-card class="cardDadosNfeBordaDupli">
                <div class="rowContent" v-if="!dadosNfe.idVenda">
                  <!-- <div class="input-group">
                    <input
                      type="date"
                      class="input borderInput"
                      v-model="duplicates.fistExpiration"
                    />
                    <label class="user-label"> Data do 1º Vencimento </label>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled">Tipo de Pagamento</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="id"
                      text-field="tipo"
                      :options="typePayments"
                      v-model="duplicates.idTypePayment"
                    >
                    </b-form-select>
                  </div> -->
                  <!-- <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Conta de recebimento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="id"
                      text-field="nome"
                      :options="receiptAccounts"
                      v-model="duplicates.idReceiptAccount"
                    >
                    </b-form-select>
                  </div> -->
                  <!-- <div class="input-group">
                    <input
                      class="input borderInput"
                      v-model="duplicates.dateInterval"
                    />
                    <label class="user-label"> Intervalo de Vencimento </label>
                  </div>
                  <div class="input-group">
                    <input
                      class="input borderInput"
                      v-model="duplicates.installments"
                    />
                    <label class="user-label"> Quantidade de Parcelas </label>
                  </div> -->

                  <GenerateBills
                    ref="generateBillsRef"
                    :idCliente="dadosNfe.idCliente"
                    :saleId="dadosNfe.id"
                    :typeItem="{ typeId: 'idNota', id: dadosNfe.id }"
                    :totalValue="Math.round(this.dadosNfe.total * 100) / 100"
                    :allPaymentsTypes="allPaymentsTypes"
                    :isClear="newOrder"
                    :findBills="isFindBills"
                    @listPaymentMethods="getAllPayments"
                  />
                </div>

                <!-- <div class="ContentTable">
                  <table style="width: 100%">
                    <thead
                      style="
                        color: whitesmoke;
                        background: #3a4750;
                        text-align: center;
                        height: 27px;
                      "
                    >
                      <tr>
                        <th>Data vencimento</th>
                        <th>Valor da parcela</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody style="color: #3a4750; width: 100%">
                      <tr
                        style="text-align: center; height: 27px"
                        v-for="bill in billsFromTable"
                        :key="bill.id"
                      >
                        <td>{{ bill.data | formatDate }}</td>
                        <td>{{ maskCurrency(bill.valorTotal) }}</td>
                        <td v-if="!dadosNfe.idVenda">
                          <b-button
                            size="sm"
                            variant="light"
                            style="color: red"
                            :disabled="
                              bill.idVenda || bill.idVendaMtq ? true : false
                            "
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Excluir',
                            }"
                            @click="deleteBill(bill.id)"
                          >
                            <b-icon-x-circle></b-icon-x-circle
                          ></b-button>
                        </td>
                        <td v-else>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="rowContent"
                  style="margin-top: 30px"
                  v-if="!dadosNfe.idVenda"
                >
                  <div class="btnsContainer">
                    <b-button
                      style="padding: 5px"
                      class="btnsSaveNeutral"
                      @click="getAllBillsByIdNota"
                      >Fechar</b-button
                    >
                    <b-button
                      class="btnsSave"
                      style="padding: 5px"
                      @click="makingThePayment"
                      >Lançar Pagamento</b-button
                    >
                  </div>
                </div> -->
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>
    <div class="rowContentFooter">
      <div class="btnsContainerFooterInit">
        <b-button class="btnsSaveNeutral" @click="clearInputs"
          >Nova Emissão fiscal</b-button
        >
        <b-button
          v-if="this.dadosNfe.id"
          class="btnsSave"
          @click="updateOrSaveNotaFiscal"
          >Atualizar</b-button
        >
        <b-button
          v-if="!this.dadosNfe.id"
          class="btnsSave"
          @click="updateOrSaveNotaFiscal"
          >Salvar</b-button
        >
      </div>
      <div class="btnsContainerFooter">
        <b-button class="btnsSave" @click="previewNote()"
          >Pré-Visualização</b-button
        >
        <b-button
          class="btnsSave"
          v-if="
            responseNfeWebMania.status === 'aprovado' ||
            responseNfeWebMania.status === 'processamento'
          "
          @click="visualizarNfe(dadosNfe.id)"
          >Visualizar</b-button
        >

        <b-button
          style="position: relative"
          class="btnsSave"
          :disabled="
            loadginSendNfe ||
            dadosNfe.status === 'Processamento' ||
            dadosNfe.status === 'Contingência'
          "
          @click="handleEmitOrReturnNota"
          >Emitir
          <b-spinner
            v-if="loadginSendNfe"
            style="
              width: 15px;
              height: 15px;
              position: absolute;
              right: 5px;
              top: 25%;
            "
            variant="primary"
        /></b-button>

        <b-dropdown
          text="Ações"
          class="btnsAction"
          variant="light"
          style="color: white"
        >
          <template #button-content>
            <b-icon-gear></b-icon-gear>
          </template>
          <b-dropdown-item
            :disabled="
              dadosNfe.status === 'Cancelada' || dadosNfe.status === ''
                ? true
                : false
            "
            @click="openModals('modalCancelNota')"
            >Cancelar
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            :disabled="
              responseNfeWebMania.status === 'aprovado' ||
              responseNfeWebMania.status === 'processamento' ||
              responseNfeWebMania.status === 'cancelado'
                ? true
                : false
            "
            >Inutilizar
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            :disabled="
              dadosNfe.status === 'Não Enviada' ||
              dadosNfe.status === 'Cancelada' ||
              dadosNfe.status === ''
                ? true
                : false
            "
            @click="openModalCorrectionLetter"
            >Carta de correção</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div>
      <b-modal
        id="modalReturnNota"
        size="lg"
        title="Selecione os produtos que deseja devolver!"
        centered
      >
        <template #modal-footer>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-between"
          >
            <div>
              <b-button
                variant="info"
                :disabled="handleReturnedAmmoutAndAmmount()"
                size="sm"
                @click="sendEntryNotaDevolution"
                >Prosseguir</b-button
              >
            </div>

            <div v-if="spinLoadingDevolucao">
              <b-spinner
                style="width: 2rem; height: 2rem"
                variant="primary"
              ></b-spinner>
            </div>
          </div>
        </template>
        <b-row class="col-sm-12 tableReturnProducts">
          <table class="table table-sm">
            <thead>
              <tr style="background-color: #3a4750; color: white">
                <th>Produto</th>
                <th>Quantidade</th>
                <th>Qnt. Devolvida</th>
                <th>Vl. und</th>
                <th>Vl. total</th>
                <th>Selecionar</th>
              </tr>
              <tr
                v-for="(products, index) in producsReferencedNotaFinal"
                :key="products.id"
              >
                <td class="tdReturnProducts">{{ products.nome }}</td>
                <td class="tdReturnProducts">{{ products.quantidade }}</td>
                <td class="tdReturnProducts">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center"
                  >
                    <b-form-input
                      size="sm"
                      type="number"
                      v-model="producsReferencedNotaFinal[index].qtdDevolvida"
                      class="col-sm-12 col-md-12 col-lg-5 col-xl-5"
                    />
                  </div>
                </td>
                <td class="tdReturnProducts">{{ products.subtotal }}</td>
                <td class="tdReturnProducts">{{ products.total }}</td>
                <td class="tdReturnProducts">
                  <b-form-checkbox
                    name="checkbox-1"
                    v-model="producsReferencedNotaFinal[index].isDevolucao"
                    size="lg"
                    @change="chekedProductsReturnNota(index)"
                    id=""
                  />
                </td>
              </tr>
            </thead>
          </table>
        </b-row>
      </b-modal>
    </div>

    <ModalCreateCustomer
      :idCustomerFromSearch="dadosNfe.idCliente"
      @getAllNewCustomer="handleCreatedNewCustomer"
    />
    <ModalCreateProduct
      :idProductFromSearch="idProductFromSearch"
      @getAllNewProduct="handleCreatedNewProduct"
    />
    <ModalShippingCompany />
    <ModalCancelNota
      :idNota="{
        uuidNotaWebMania: responseNfeWebMania.uuid,
        idNota: dadosNfe.id,
      }"
      @getNotaAfterCanceled="handleFindNota"
    />
    <ModalCorrectionLetter
      :idNota="dadosNfe.id"
      @getNotaAfterCorrection="findNotaById"
    />

    <ModalTaxInformation
      @createdNewRef="createdNewRef = $event"
      @closeModal="handleCloseModalRef"
      :refFromSearch="refFromSearch"
    />

    <ModalCreateNatureOps @getNewNature="getAllNatures" />
  </div>
</template>

<script>
import mixinNotaFiscal from "../../mixins/NotaFiscal/NotaFiscal";
import RefFiscalFilters from "../../mixins/RefFiscalFilters";

export default {
  mixins: [mixinNotaFiscal, RefFiscalFilters],
};
</script>

<style scoped>
.containerGeralNfe {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
  margin-bottom: 100px;
}

.conteudoBotaoEmail {
  height: 35px;
  display: flex;
  justify-content: space-between;
}

.conteudoBotaoEmail button:hover {
  background-color: #025f6b !important;
  transition: all 0.3s linear;
}
.input:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.inputTotals input:hover {
  background: #d9d9d9 !important;
  border: 1px solid #262626;
}
.custom-select:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.textarea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.inputTextArea:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}
.conteudoBotaoEmail button {
  margin-left: 16px;
}

.conteudoDadosNfe {
  border-radius: 5px;
  padding: 0 !important;
  margin-top: 10px;
}

.cardDadosNfe {
  padding-bottom: 15px !important;
  border-radius: 5px !important;
  border: 1px solid rgba(232, 231, 231, 0.788);
  background-color: #f9f9f94d !important;
  padding: 0px 0px 0px 0px !important;
  border-radius: 5px !important;
  width: 100%;
}

.cardDadosNfeBorda {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.iconSelectBarCode {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: black;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}
.cardDadosNfeBordaDupli {
  border-radius: 5px !important;
  margin-bottom: 40px;
}

.tamanhoCards {
  width: 100%;
  display: flex;
}

.contentRemovePescription {
  display: flex;
  flex-direction: column;
  align-content: center;
  gap: 0.1rem;
  padding: 0.3rem 0.5rem;
  background-color: rgb(179 178 176 / 35%);
  border-radius: 5px;
  position: relative;
}

.iconRemovePrescription {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 23px;
  height: 23px;
  cursor: pointer;
  background-color: #ff4d4d;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 2px white;
  z-index: 10;
  font-size: 11px;
  line-height: 1;
  color: white;
}

.dropdown-menu {
  display: none;
  font-size: 12px;
  color: #212529;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
  height: 20px;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

td {
  text-transform: capitalize;
}

.tamanhoBotaoOpenCard {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.tamanhoBotaoOpenCardFinaly {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.chkSaidaEntrada {
  margin-top: 18px;
}

.containerCheckBox {
  display: flex;
  height: 30.1px !important;
  width: 125px !important;
  align-items: center !important;
  border: solid 1px rgb(216, 215, 215);
  border-radius: 5px;
  padding-left: 15px !important;
  margin-right: 16px;
}

.iconCadTransportadora {
  display: flex;
  justify-content: space-between;
}

.btnCadTransportadora {
  cursor: pointer;
}

.inputCustomer {
  width: 45%;
}

.inputdate {
  width: 15% !important;
}

.tableReturnProducts {
  margin-top: 31px;
  overflow: auto !important;
  max-height: 300px;
  text-align: center;
}

.tdReturnProducts {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

#dadosNfeStyle {
  border: none !important;
}

.btnFormaPagamento {
  cursor: pointer;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

@media screen and (max-width: 438px) {
  .contentDataNfeRow {
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-width: 388px) {
  .additionalButtonContent {
    display: flex;
    flex-direction: column;
  }
  .conteudoBotaoEmail {
    height: 30px !important;
  }
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  z-index: 10;
}

.user-label-sm {
  position: absolute;
  left: 130px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.selectPlusSm {
  position: relative;
  width: 20%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 30px;
  left: 0px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
}

.itemToggleDesc {
  width: 55px;
  height: 30px;
  position: relative;
  display: flex;
}

/* The slider */

.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.user-label-disabled {
  position: absolute;
  left: 10px;
  font-size: 9px;
  bottom: 22px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.user-label-ncm {
  position: absolute;
  left: 10px;
  font-size: 10px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.user-label-data {
  position: absolute;
  left: 7px;
  font-size: 11px;
  bottom: 8px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px !important;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px !important;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  box-shadow: none !important;
  border: 1px solid #505050;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 10px;
  border-bottom: 1px solid rgb(230, 230, 230);
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.item-tax-ref-field {
  position: relative;
  width: 30%;
  min-width: 0;
}

.item-tax-ref-field-ref {
  box-sizing: border-box;
  /* padding-right: 24px; */
}

.rowContentFooter {
  display: flex;
  width: 80vw;
  padding: 15px 10px 30px 10px;
  justify-content: space-between;
  gap: 10px;
  height: 60px;
  bottom: 0;
  background: #f9f9f9;
  position: fixed;
  z-index: 8000;
}

.rowObservation {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: 40px;
}

.btnsContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.btnsContainerFooter {
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.btnsContainerFooterInit {
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
}

.btnsSave {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
}

.btnsAction {
  border-radius: 4px;
  width: 65px;
  border: 1px solid rgb(222, 221, 221);
  color: white;
  height: 30px;
  display: flex;
  font-size: 12px !important;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #ececec;
  width: 165px;
  border: 1px solid rgb(222, 221, 221);
  color: rgb(0, 0, 0);
  font-size: 12px;
}

.input-group {
  width: 30%;
}

.input-group-time {
  width: 15%;
}

.input-groupSm {
  width: 20%;
}

.input-group-ob {
  width: 100%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0;
}

.descriptionObs {
  margin: 0px;
  color: #666360;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
  font-size: 11px;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.card {
  border: none !important;
}

.inputNameShippingCompany {
  width: 70%;
}

@media screen and (max-width: 800px) {
  .rowContentShippingCompany {
    flex-wrap: wrap;
    justify-content: start;
  }

  .inputNameShippingCompany {
    width: 100%;
  }

  .inputShippingCompanyMd {
    width: 48.82%;
    margin-top: 10px;
  }

  .inputShippingCompanySm {
    width: 32%;
  }
}

@media screen and (max-width: 700px) {
  .rowContent {
    flex-direction: column;
  }
  .selectPlus {
    width: 100%;
  }
  .input-group {
    width: 100% !important;
  }
  .selectPlusSm {
    width: 100%;
  }
  .input-groupSm {
    width: 100%;
  }
  .user-label-sm {
    left: 30px !important;
  }
  .rowContentFooter {
    display: flex;
    width: 100vw !important;
    padding: 5px;
    gap: 5px;
    height: 60px;
    bottom: 0;
  }
  .btnsSave {
    width: 100px;
    font-size: 11px;
  }
  .btnsSaveNeutral {
    width: 100px;
    font-size: 11px;
  }

  .inputCustomer,
  .inputdate {
    width: 100%;
  }
}
@media screen and (max-width: 450px) {
  .btnsSave {
    width: 45%;
    font-size: 12px;
    padding: 10px 0;
    text-align: center;
  }
}
</style>
